module.exports = __webpack_public_path__ + "static/img/quantijingyin2.a1b6c7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/quantijingyin2.png
// module id = +wxN
// module chunks = 24